import { createContext, useContext } from "react";
import type { HomeSectionId } from "../content/siteContent";

type HomeNavigationSource = "nav" | "hash";

type HomeNavigationContextValue = {
  navigateSection: (id: HomeSectionId, source?: HomeNavigationSource) => void;
};

export const HomeNavigationContext = createContext<HomeNavigationContextValue | null>(null);

export function useHomeNavigation() {
  return useContext(HomeNavigationContext);
}

export function getHomeSectionIdFromHref(href: string): HomeSectionId | null {
  const match = href.match(/^\/#([^#/?]+)$/);
  if (!match) {
    return null;
  }

  const sectionId = match[1] as HomeSectionId;
  if (sectionId === "studio" || sectionId === "projects" || sectionId === "team" || sectionId === "about" || sectionId === "contact") {
    return sectionId;
  }

  return null;
}
